import { createFileRoute, Outlet } from '@tanstack/react-router';
import { authRouteMiddleware } from '@/middlewares/auth-middleware';

export const Route = createFileRoute('/creation')({
  component: Outlet,
  server: {
    middleware: [authRouteMiddleware],
  },
});
